import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherConversion from "./WeatherConversion";

export default function WeatherInfo(props){
    return (
        <div className="WeatherInfo">
        <h1 className = "title mb-1">{props.data.city}</h1>
            <ul>
                <li><FormattedDate date={props.data.date} /></li>
                <li class="text-capitalize">{props.data.description}</li>
            </ul>
            <div className = "row mt-3">
                <div className="col-6">
                    <div className="float-left">
                        <WeatherIcon code={props.data.icon} size={60} />
                    </div>

                    <div className = "float-left">
                        <WeatherConversion celcius={props.data.temperature} />
                    </div>
                </div>
                <div className = "col-6">
                    <ul>
                        <li>Humidity: {props.data.humidity}%</li>
                        <li>Wind: {props.data.wind} km/hr</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}